export const Mutations = {
  isAdmin: (state, {IsAdmin}) => {
    state.isAdmin = IsAdmin
  },
  setAuthentication (state, auth) {
    state.authenticated = auth
  },
  resetAuthentication (state) {
    state.authenticated = false
  },
  setFrontEndAppSettings (state, settings) {
    state.settings.setSettings(settings)
  },
  updateFrontEndAppSettings (state, settings) {
    const settingsCopy = Object.assign(state.settings, settings)
    state.settings = settingsCopy
  },
  toggleSplashScreen (state, value) {
    state.showSplashScreen = value
  },
  setSplashScreenMessage (state, message) {
    state.splashScreenMessage = message
  },
  toggleSideNav (state, value) {
    state.showSideNav = value
  },
  setBrowser (state, browser) {
    state.browser = browser
  },
  addPromise (state, { promise, scopes }) {
    state.loadingPromiseUtil.add(promise, scopes)
  },
  cacheRoute (state, route) {
    state.cachedRoute = route
  },
  clearCachedRoute (state) {
    state.cachedRoute = null
  }
}
